import { Component, OnInit } from '@angular/core';
import { Route, RouteService } from '../../services/route';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Delivery } from '../../services/app/delivery-service';
import { DeliveryItem } from '../../services/app/delivery-item';

@Component({
  selector: 'create-route-screen',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './create-route-screen.html',
  styleUrl: './create-route-screen.css',
})
export class CreateRouteScreen implements OnInit {
  route: Route;
  activeDelivery: Delivery;
  activeItem: DeliveryItem;


  constructor(private routeService: RouteService){

  }

  loadFromOrders(){
    this.route.deliveries.push(new Delivery());
  }

  addStop(){
    this.route.deliveries.push(new Delivery());
  }

  addItem(){
    this.activeDelivery.items.push(this.activeItem);
    this.activeItem = new DeliveryItem();
  }
  removeItem(index: number){
    this.activeDelivery.items.splice(index, 1);
  }

  async saveDelivery(){
    const route = await this.routeService.create(this.route);
    if(route){
      this.route = new Route();
    }
  }

  async ngOnInit(): Promise<void> {
    this.activeDelivery = new Delivery();
    this.activeItem = new DeliveryItem();
    this.route = new Route();
  }

}
